import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import '../login/login.css'
import '../header/header.css'
import Logo from "../../../src/assets/images/godrej-logo-dark.svg"
import Pageimg from "../../assets/images/8D_loginPage.jpg"
import 'mdb-react-ui-kit/dist/css/mdb.min.css';

const Login = () => {
    const { instance } = useMsal();
    const [isLoading, setIsLoading] = useState(false);
    const [loginType, setLoginType] = useState('godrej'); // Supplier logic: tracks login type (godrej or supplier)

    // Supplier logic: generate PKCE challenge for B2C supplier authentication
    const generatePKCE = async () => {
        const array = new Uint8Array(32);
        crypto.getRandomValues(array);
        const verifier = btoa(String.fromCharCode(...array))
            .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        const encoded = new TextEncoder().encode(verifier);
        const hash = await crypto.subtle.digest('SHA-256', encoded);
        const challenge = btoa(String.fromCharCode(...new Uint8Array(hash)))
            .replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        return { verifier, challenge };
    };

    const handleLogin = async () => {
        setIsLoading(true);
        try {
            if (loginType === 'supplier') { // Supplier logic: redirect to B2C login for supplier users
                const { verifier, challenge } = await generatePKCE();
                localStorage.setItem('b2c_code_verifier', verifier);
                const clientId = process.env.REACT_APP_B2C_CLIENTID;
                const authorityDomain = process.env.REACT_APP_B2C_AUTHORITY_DOMAIN;
                const tenant = process.env.REACT_APP_B2C_TENANT;
                const policy = process.env.REACT_APP_B2C_SIGNIN_FLOW;
                const redirectUri = encodeURIComponent(process.env.REACT_APP_B2C_REDIRECTURI);
                const b2cUrl = `https://${authorityDomain}/${tenant}/oauth2/v2.0/authorize?p=${policy}&client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&scope=openid%20profile&response_mode=query&state=supplier_login&prompt=login&code_challenge=${challenge}&code_challenge_method=S256`;
                window.location.assign(b2cUrl);
            } else {
                if (!instance) throw new Error("MSAL instance not initialized");
                await instance.loginRedirect({ ...loginRequest, redirectUri: window.location.origin + "/" });
            }
        } catch (error) {
            console.error("Login failed:", error);
            setIsLoading(false);
        }
    };

    return (
        <section class="login">
            <header class="header">
                <img src={Logo} alt="Godrej Logo"></img>
                <div class="header-text">Godrej Enterprises Group</div>
            </header>
            <div className="container-fluid">
                <div className="logoBlock row float-right">
                    <div className="col-12 col-sm-6 text-right">
                        {/* Logo placeholder */}
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="row">
                <div class="branding col-12 col-sm-8 col-md-8">
                    <img src={Pageimg} alt="Login" class="w-100 d-flex" />
                </div>
                <div class="loginForm col-12 col-sm-4 col-md-4 col-md-offset-1 float-right">
                    <form className="col-12 col-sm-10 col-lg-12">
                        <mat-card-content>
                            <div className="text-start mb-4 godrejPurple">
                                <h1>8D System</h1>
                            </div>
                            <div className="mb-3 radio-group">
                                <div className="radio-option">
                                    <input 
                                        type="radio" 
                                        id="godrej" 
                                        name="loginType" 
                                        value="godrej" 
                                        checked={loginType === 'godrej'} 
                                        onChange={(e) => setLoginType(e.target.value)}
                                        className="godrej-radio" 
                                    />
                                    <label htmlFor="godrej" className="godrej-radio-label">Godrej Employee</label>
                                </div>
                                {/* Supplier logic: radio option to select Supplier login type */}
                                <div className="radio-option">
                                    <input 
                                        type="radio" 
                                        id="supplier" 
                                        name="loginType" 
                                        value="supplier" 
                                        checked={loginType === 'supplier'} 
                                        onChange={(e) => setLoginType(e.target.value)}
                                        className="godrej-radio" 
                                    />
                                    <label htmlFor="supplier" className="godrej-radio-label">Supplier</label>
                                </div>
                            </div>
                            <div className="submitBtn">
                                <button 
                                    type="button" 
                                    onClick={handleLogin} 
                                    disabled={isLoading}
                                    aria-busy={isLoading}
                                >
                                    {/* Supplier logic: show 'Supplier Login' button text when supplier is selected */}
                                    {isLoading ? 'Signing in...' : loginType === 'supplier' ? 'Supplier Login' : 'Login'}
                                </button>
                            </div>
                        </mat-card-content>
                    </form>
                </div>
            </div>
        </section>
    );
};
export default Login;
